import getData from "@/api/salesforce";
import GET_USERINFO from "@/api/salesforce/cpq-quote-api/getUserInfo";

async function getSalesforceUserInfo(accessToken: string) {
  let data;
  try {
    data = await getData({
      connection: GET_USERINFO(),
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return { data: data, error: data?.error || null };
} catch (error: any) {
    throw new URIError(error);
  }
}

export default getSalesforceUserInfo;